import React, { useState, useEffect, useCallback } from "react";
import axios from "axios";
import { useParams } from "react-router-dom";
import { useNavigate } from "react-router-dom";

//import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";

import EditIcon from "@mui/icons-material/Edit";
import Breadcrumbs from "@mui/material/Breadcrumbs";
import Link from "@mui/material/Link";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";

import Device from "Components/Shared/Device/Device";
//import DeviceNotifications from "Components/Shared/DeviceNotifications/DeviceNotifications";
//import Table from "Components/Shared/Table/Table";
import HistoryGraph from "Components/Shared/HistoryGraph/HistoryGraph";
import DeviceFormModal from "./DeviceFormModal";

import SideBar from "Components/Shared/SideBar/SideBar";
import AttentionBox from "Components/Shared/AttentionBox/AttentionBox";
import BottomBar from "Components/Shared/BottomBar/BottomBar";

//redux setup
import { useSelector, useDispatch } from "react-redux";
import {
	//setDevices,
	//setNotifications,
	//setDeviceModalState,
	setDeviceModalVisibility,
} from "Store/home";

import "./DevicePage.css";

const DevicePage = () => {
	const [deviceData, setDeviceData] = useState({
		deviceId: "",
		clientName: "",
		client: "",
		name: "",
		siteName: "",
		buildingName: "",
		areaName: "",
		tempSet: 0,
		tempVal: 0,
		tempDiff: 0.5,
		powerOn: 0,
		heaterOn: 0,
		coolerOn: 0,
	});
	const state = useSelector((state: any) => state.homeState);
	const dispatch = useDispatch();
	const { deviceId } = useParams();

	const [deviceNotifications, setDeviceNotifications] = useState([]);
	const [alarmNotifications, setAlarmNotifications] = useState([]);
	const [alarmNum, setAlarmNum] = useState(0);

	const serverUrl = `${process.env.REACT_APP_PROTOCOL}://${process.env.REACT_APP_SERVER_HOST}:${process.env.REACT_APP_SERVER_HOST_PORT}`;

	useEffect(() => {
		let notifications = state.deviceNotifications;
		let alarms = state.alarmNotifications;
		setDeviceNotifications(
			notifications.filter(
				(device: any) => device.deviceId === Number(deviceId)
			)
		);
		const deviceAlarms = alarms.filter(
			(device: any) => device.deviceId === Number(deviceId)
		);
		setAlarmNotifications(deviceAlarms);
		setAlarmNum(deviceAlarms.length);
	}, [deviceId, state.alarmNotifications, state.deviceNotifications]);

	const fetchData = useCallback(() => {
		axios
			.post(
				`${serverUrl}/api/device`,
				{
					deviceId: Number(deviceId),
				},
				{
					withCredentials: true,
				}
			)
			.then(async function (response) {
				const apiData = await response.data;

				if (apiData.status === "success") {
					setDeviceData(apiData.data[0]);
					//console.log(apiData.data[0]);
				} else {
					setDeviceData({
						deviceId: "",
						clientName: "",
						client: "",
						name: "",
						siteName: "",
						buildingName: "",
						areaName: "",
						tempSet: 0,
						tempVal: 0,
						tempDiff: 0,
						powerOn: 0,
						heaterOn: 0,
						coolerOn: 0,
					});
				}
			})
			.catch(function (error) {
				console.error(error);
				setDeviceData({
					deviceId: "",
					clientName: "",
					client: "",
					name: "",
					siteName: "",
					buildingName: "",
					areaName: "",
					tempSet: 0,
					tempVal: 0,
					tempDiff: 0,
					powerOn: 0,
					heaterOn: 0,
					coolerOn: 0,
				});
			});
	}, [deviceId, serverUrl]);

	useEffect(() => {
		fetchData();
	}, [fetchData]);

	const handleModal = () => {
		dispatch(setDeviceModalVisibility(true));
	};

	const [deviceBootLength, setDeviceBootLength] = useState({
		device: 1,
		table: 11,
	});

	useEffect(() => {
		const screenWidth = window.innerWidth;
		screenWidth < 1200
			? setDeviceBootLength({
					device: 2,
					table: 10,
			  })
			: setDeviceBootLength({
					device: 1,
					table: 11,
			  });
	}, []);

	const breadcrumbs = [
		<Link
			key="1"
			color="inherit"
			underline="none"
		>
			{deviceData.siteName}
		</Link>,
		<Link
			key="2"
			color="inherit"
			underline="none"
		>
			{deviceData.buildingName}
		</Link>,
		<Link
			key="2"
			color="inherit"
			underline="none"
		>
			{deviceData.areaName}
		</Link>,
	];

	const redirect = useNavigate();

	const handleHomeRedirect = () => {
		redirect("/");
	};

	return (
		<>
			<BottomBar alerts={alarmNum} />
			<div className="temp-mobi-header">
				<img
					className=""
					alt="logo"
					src="/media/icons/logoV2.png"
					onClick={() => handleHomeRedirect()}
					style={{ cursor: "pointer" }}
				/>
			</div>
			<Row className="home-container">
				<Col
					md={1}
					className="sidebar-col"
				>
					<SideBar />
				</Col>
				<DeviceFormModal
					fetchData={fetchData}
					device={deviceData}
					visibility={state.deviceModalVisibility}
					dispatch={dispatch}
					setDeviceModalVisibility={setDeviceModalVisibility}
				/>
				<Col md={11}>
					<Row className="details-row">
						<h4 className="device-heading device-icon-heading">
							{deviceData.name}{" "}
							{/* <EditIcon
								className="edit"
								onClick={() => handleModal()}
							/> */}
							<img
								src="/media/icons/penEdit.png"
								alt="edit icon"
								onClick={() => handleModal()}
								className="edit-icon-img"
							/>
						</h4>
						<Breadcrumbs
							separator={<NavigateNextIcon fontSize="small" />}
							aria-label="breadcrumb"
							className="bread-crumbs"
						>
							{breadcrumbs}
						</Breadcrumbs>
					</Row>
					<Row className="device-page-container">
						<Col
							md={4}
							style={{ padding: "0 2px" }}
							className="dp-mobi-col"
						>
							<div>
								<div className="device-status-row">
									<div
										style={
											!deviceData.powerOn
												? {
														filter: "brightness(0.9) grayscale(1)",
														opacity: 0.2,
												  }
												: {}
										}
									>
										<img
											src="/media/icons/onOff.png"
											alt="power"
											className="device-temp-hot"
										/>
									</div>
									<div
										style={
											deviceData.coolerOn && deviceData.powerOn
												? {}
												: {
														filter: "brightness(0.9) grayscale(1)",
														opacity: 0.2,
												  }
										}
									>
										<img
											src="/media/icons/deviceCooling.png"
											alt="cooling"
											className="device-temp-hot"
										/>
									</div>
									<div
										style={
											deviceData.heaterOn && deviceData.powerOn
												? {}
												: {
														filter: "brightness(0.9) grayscale(1)",
														opacity: 0.2,
												  }
										}
									>
										<img
											src="/media/icons/heatingLg.png"
											alt="heating"
											className="device-temp-hot"
										/>
									</div>
									<div
										style={
											!deviceData.powerOn
												? {
														filter: "brightness(0.9) grayscale(1)",
														opacity: 0.2,
												  }
												: {}
										}
									>
										<img
											src="/media/icons/pipe.png"
											alt="neutral"
											className="device-temp-hot"
										/>
									</div>
								</div>
								<Device
									device={deviceData}
									state={""}
									graph={false}
									show={true}
									myGraph={false}
									page="devicePage"
								/>
							</div>
						</Col>
						<Col md={4}>
							<AttentionBox
								rowData={alarmNotifications}
								header="Needs Attention"
								mainClass="attention-box"
								secondaryClass="attention-item"
								page="devicePage"
							/>
						</Col>
						<Col md={4}>
							<AttentionBox
								rowData={deviceNotifications}
								header="Latest Activity"
								mainClass="activity-box"
								secondaryClass="activity-item"
								page="devicePage"
							/>
						</Col>
					</Row>

					<HistoryGraph
						interval={false}
						//clientId={deviceData.client}
						deviceId={deviceId}
						agg={1}
						type="24hour"
						height={300}
						tools={true}
						filter={true}
						leftMargin={true}
					/>
				</Col>
			</Row>
		</>
	);
};

export default DevicePage;
